export default __webpack_public_path__ + "static/media/echo3Dwhite.c2df8fee.png";